import { NavLink } from "react-router";
// import Logo  from '../assets/images/IETBHEC.png'
// import Danang_Desktop from '../assets/images/DH Danang.png'
// import Danang_Mobile from '../assets/images/DH Danang.png'

function Header() {
	return (
		<header className="header" id="header">
			<div>
				<div className="hamburger mr-3" onClick={openNav}>
					<i className="fa fa-bars" aria-hidden="true"></i>
				</div>
				{/* <div className="header_top">
					<div className="row">
						<div className="col">
							<div className="header_top_content d-flex align-items-center justify-content-between w-100 px-3">

								<div className="d-flex align-items-center">
									<div className="hamburger mr-3" onClick={openNav}>
										<i className="fa fa-bars" aria-hidden="true"></i>
									</div>

									<NavLink to="/">
										<img src={Logo} alt="Logo" className="main-logo" />
									</NavLink>
								</div>

								<div className="d-flex align-items-center gap-3">
									<img src={Danang_Desktop} alt="Danang_Desktop" className="partner-logo danang-logo hero-desktop-img" />
									<img src={Danang_Mobile} alt="Danang_Mobile" className="partner-logo danang-logo hero-mobile-img" />
								</div>

							</div>
						</div>
					</div>
				</div> */}
				<div className="header_nav" id="header_nav_pin">
					<div className="page-container">
						<div className="header_nav_inner">
							<div className="header_nav_container">

								<div className="header_nav_content d-flex flex-row align-items-center justify-content-center">
									<nav className="main_nav">
										<ul>
											<li><NavLink className="navlink-style" to="/">Home</NavLink></li>
											<li><NavLink className="navlink-style" to="/about">About IETEC</NavLink></li>
											<li><NavLink className="navlink-style" to="/call-for-papers">Call for Papers</NavLink></li>
											<li><NavLink className="navlink-style" to="/masterclasses-workshops">Masterclasses/Workshops</NavLink></li>
											<li><NavLink className="navlink-style" to="/registration">Registration</NavLink></li>
											<li><NavLink className="navlink-style" to="/sponsorship-exhibition">Sponsorship and Exhibition</NavLink></li>
											<li><NavLink className="navlink-style" to="/venue-accommodation">Venue and Accommodation</NavLink></li>
											<li><NavLink className="navlink-style" to="/program-outline">Program Outline</NavLink></li>
											{/* <li><NavLink className="navlink-style" to="/committee">Organising Committee</NavLink></li> */}
											<li><NavLink className="navlink-style" to="/contact-us">Contact Us</NavLink></li>
										</ul>
									</nav>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
	)
}

function openNav() {
	document.getElementById("mySidenav").style.width = "250px";
}

export default Header